import { useMemo } from 'react';
import { useGetParams } from './hooks/useGetParams';

import AdvtFullSize from './components/AdvtFullSize/AdvtFullSize';
import { WordCloud } from './components/WordCloud/WordCloud';

import { useMultiBroadcast } from './hooks/useMultiBroadcast';

import defaultBackground from './assets/images/bg.png';

const testWords = [
  {
    text: 'ДОСТИЖЕНИЕ РЕЗУЛЬТАТА НЕВОЗМОЖНО В ОДИНОЧКУ',
    value: 1,
  },
  {
    text: 'НАЦЕЛЕННОСТЬ НА РЕЗУЛЬТАТ!',
    value: 2,
  },
  {
    text: 'МЫ БУДЕМ ЛУЧШИМИ!',
    value: 1,
  },
  {
    text: 'КОМАНДНОСТЬ И ПАРТНЕРСТВО',
    value: 3,
  },
  {
    text: 'ЕДИНЕНИЕ',
    value: 1,
  },
  {
    text: 'ВДОХНОВЛЯЕТ',
    value: 5,
  },
  {
    text: 'СМЫСЛ',
    value: 1,
  },
  {
    text: 'МЫ - КОМАНДА!',
    value: 100,
  },
  {
    text: 'АМБИЦИОЗНОСТЬ И ЖЕЛАНИЕ ДОСТИЖЕНИЯ ЦЕЛЕЙ',
    value: 7,
  },
  {
    text: 'УВЕРЕННОСТЬ',
    value: 1,
  },
  {
    text: 'ДОВЕРИЕ',
    value: 10,
  },
  {
    text: 'КОМАНДА',
    value: 1,
  },
  {
    text: 'ВМЕСТЕ!',
    value: 29,
  },
  {
    text: 'СИЛА В КОМАНДЕ',
    value: 1,
  },
  {
    text: 'СИЛА КОМАНДЫ',
    value: 55,
  },
  {
    text: 'ПАРТНЕРСТВО',
    value: 1,
  },
  {
    text: 'ПОБЕДА',
    value: 45,
  },
  {
    text: 'СИЛА В ЕДИНСТВЕ',
    value: 1,
  },
  {
    text: 'ВООДУШЕВЛЕНИЕ',
    value: 23,
  },
  {
    text: 'УСПЕХ',
    value: 1,
  },
  {
    text: 'ВСЕ ПОЛУЧИТСЯ',
    value: 1,
  },
  {
    text: 'КОМАНДНЫЙ ДУХ',
    value: 54,
  },
  {
    text: 'ВМЕСТЕ',
    value: 1,
  },
  {
    text: 'ЕДИНСТВО',
    value: 1,
  },
  {
    text: 'СИЛА В КОМАНДЕ',
    value: 58,
  },
  {
    text: 'ВЕРА В КОМАНДУ',
    value: 1,
  },
  {
    text: 'МЫ КОМАНДА',
    value: 1,
  },
  {
    text: 'КОМАНДА РЕШАЕТ!!!',
    value: 1,
  },
  {
    text: 'КОМАНДА - СИЛА',
    value: 22,
  },
  {
    text: 'ВДОХНОВЕНИЕ',
    value: 1,
  },
  {
    text: 'ЭНЕРГИЮ КОМАНДЫ!',
    value: 1,
  },
  {
    text: 'СМОЖЕМ',
    value: 53,
  },
  {
    text: 'ЛЮДИ СБЕРА-СИЛА!',
    value: 1,
  },
  {
    text: 'МОТИВАЦИЯ, ЗАРЯД ЭНЕРГИИ!',
    value: 1,
  },
  {
    text: 'ЗАРЯД',
    value: 1,
  },
  {
    text: 'МОТИВАЦИЯ!',
    value: 1,
  },
  {
    text: 'ВСЕ ВОЗМОЖНО',
    value: 1,
  },
  {
    text: 'ЗАРЯД ЭНЕРГИИ',
    value: 1,
  },
  {
    text: 'ЛЮДИ ЭТО ГЛАВНОЕ',
    value: 1,
  },
  {
    text: 'КОМАНДНАЯ РАБОТА И СПЛОЧЕНИЕ',
    value: 1,
  },
  {
    text: 'МОТИВАЦИЯ',
    value: 1,
  },
  {
    text: 'ОБЩЕНИЕ',
    value: 1,
  },
  {
    text: 'ЛИДЕРСТВО',
    value: 1,
  },
  {
    text: 'ТОЛЬКО ВПЕРЕД!',
    value: 1,
  },
  {
    text: 'МЫ СИЛЬНАЯ КОМАНДА!!!',
    value: 1,
  },
  {
    text: 'ПОРА ДОГОВАРИВАТЬСЯ!',
    value: 1,
  },
  {
    text: 'СИЛА В КОМАНДЕ, КОМАНДЕ ПРОФЕССИОНАЛОВ!',
    value: 1,
  },
  {
    text: 'ВЗАИМОПОМОЩЬ',
    value: 1,
  },
  {
    text: 'ВКУС ПОБЕДЫ!',
    value: 1,
  },
  {
    text: 'ДОВЕРЯТЬ КОМАНДЕ',
    value: 1,
  },
  {
    text: 'НАСТАВНИЧЕСТВО ЭФФЕКТИВНОСТЬ БЛАГОДАРНОСТЬ',
    value: 1,
  },
  {
    text: 'ВАЖНОСТЬ КОМАНДНОЙ РАБОТЫ',
    value: 1,
  },
  {
    text: 'БЫТЬ ВМЕСТЕ=БЫТЬ СИЛЬНЕЕ!',
    value: 1,
  },
  {
    text: 'УВЕРЕННОСТЬ, ЧТО ВСЕ ПОЛУЧИТСЯ',
    value: 1,
  },
  {
    text: 'ВАЖНО ДУМАТЬ СООБЩА И ДЕЛАТЬ ВМЕСТЕ',
    value: 1,
  },
  {
    text: 'ВМЕСТЕ-СМОЖЕМ ВСЕ',
    value: 100,
  },
];

function App() {
  const { demo, minFontWords, maxFontWords, bg } = useGetParams();

  const options = useMemo(() => {
    return {
      colors: [
        '#FF33FF',
        '#00B3E6',
        '#E6B333',
        '#3366E6',
        '#999966',
        '#B34D4D',
        '#80B300',
        '#809900',
        '#E6B3B3',
        '#6680B3',
        '#66991A',
        '#FF99E6',
        '#66994D',
        '#B366CC',
        '#4D8000',
        '#B33300',
        '#CC80CC',
        '#991AFF',
        '#E666FF',
        '#4DB3FF',
        '#1AB399',
        '#33991A',
        '#B3B31A',
        '#00E680',
        '#4D8066',
        '#809980',
        '#1AFF33',
        '#999933',
        '#CCCC00',
        '#66E64D',
        '#4D80CC',
        '#9900B3',
        '#4DB380',
        '#6666FF',
        // '#f16125',
        // '#42B649',
        // '#2ba4dd',
        // '#18154A',
        // '#3a3132',
        // '#506e87',
        // '#ebb062',
        // '#c37575',
        // '#8e3e4b',
      ],
      enableTooltip: false,
      deterministic: true,
      // fontFamily: 'mont',
      fontSizes: [minFontWords, maxFontWords],
      fontStyle: 'normal',
      fontWeight: 'bold',
      padding: 4,
      rotations: 3,
      rotationAngles: [0, 0],
      scale: 'sqrt',
      spiral: 'rectangular',
      transitionDuration: 500,
    };
  }, [minFontWords, maxFontWords]);

  const { currentState, showedMessages, idBroadcast } = useMultiBroadcast();

  const words = useMemo(() => {
    const res = {};
    showedMessages.forEach((item, index) => {
      const word = item.message.content.toUpperCase();
      if (res[word]) {
        res[word].value += 1;
      } else {
        res[word] = {
          key: index,
          value: 1,
        };
      }
    });
    return Object.entries(res)
      .map((val) => ({
        text: val[0],
        value: val[1].value,
        key: val[1].key,
      }))
      .sort((a, b) => a.key - b.key);
  }, [showedMessages]);

  const wordsInTitre = useMemo(() => {
    return demo ? testWords : words;
  }, [words, demo, idBroadcast]);

  const background = useMemo(() => {
    return bg && bg !== '0'
      ? `url(${bg === '1' ? defaultBackground : bg}) center/cover no-repeat`
      : `none`;
  }, [bg]);

  return (
    <div className="app-wrapper" style={{ background }}>
      <AdvtFullSize />

      {currentState === 'S1' && (
        <div className="titre-wrapper">
          <WordCloud
            options={options}
            wordsInTitre={wordsInTitre}
            currentState={currentState}
          />
        </div>
      )}
    </div>
  );
}

export default App;
